import { DeleteFromShuffleDto } from '../../../dto/deletefromshuffle/deletefromshuffledto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteFromShuffleRequest extends APIRequest
{
    getDeleteFromShuffleRequest(): DeleteFromShuffleDto;
}

export class DeleteFromShuffleRequestImpl extends APIRequestDtoImpl implements DeleteFromShuffleRequest
{
    constructor(private getDeleteFromShuffleData: DeleteFromShuffleDto)
    {
        super();
    }

    getDeleteFromShuffleRequest(): DeleteFromShuffleDto
    {
        return this.getDeleteFromShuffleData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/deletefromshuffle/deletefromshufflerequest.tsx